// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "HeroSection-module--wrapper--H2d-3";
export var contactsWrapper = "HeroSection-module--contactsWrapper--zPcJ+";
export var title = "HeroSection-module--title--ny+V+";
export var contactsList = "HeroSection-module--contactsList--kYg+F";
export var dropDecorator = "HeroSection-module--dropDecorator--+MxTp";
export var circleDecorator = "HeroSection-module--circleDecorator--FoNaE";
export var workingHoursWrapper = "HeroSection-module--workingHoursWrapper--PCLKH";
export var formWrapper = "HeroSection-module--formWrapper--wnsk9";
export var container = "HeroSection-module--container--blVB9";